/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-media-manager',
    'pip-events',
    'pip-analytics__messaging',
    'breakpoints',
    'javascript-debounce',
    'pip-model'
  ],
  function (
    $,
    Mustache,
    pipMediaManager,
    pipEvents,
    pipAnalyticsMessaging,
    breakpoints,
    debounce,
    pip
  ) {
    var NUMBER_OF_THUMBNAILS_TO_DISPLAY = 4;
    var BACK_BUTTON = 'back';
    var NEXT_BUTTON = 'next';

    var view = {
      templates: {
        mediaGalleryCarouselButton: $('#media__gallery__carousel--button').html(),
        mediaGalleryCarouselTemplate: $('#media__carousel-gallery').html(),
        thumbnails: $('#media__thumbnails').html(),
      },

      selectors: {
        mainImageCarousel: '#mainImageCarousel',
        carouselMediaGallery: '.carousel__media-gallery',
        mainImage: '.media__main-image--carousel__placeholder',
        mediaGalleryContainer: '.carousel__media-gallery__container',
        mediaGalleryMainImage: '.carousel__media-gallery__main-image',
        mediaThumbnail: '.media__thumbnail',
        openExpandedView: '.media__thumbnail, .media__main-image, .media__button, .carousel__media-gallery__main-image',
        owlStageOuter: '.carousel__media-gallery .owl-stage-outer',
        thumbnails: '#thumbnails',
      },

      classes: {
        carouselItemClass: 'owl-item owl-item--increased-left-margin',
        carouselNav: 'carousel__nav',
        carouselNextNav: 'carousel__main-image-nav carousel__main-image-nav__next',
        carouselPreviousNav: 'carousel__main-image-nav carousel__main-image-nav__prev',
        hiddenMainImage: 'media__main-image--carousel__placeholder--hidden',
        selectedMediaThumbnail: 'media__thumbnail--selected',
        visibleMediaGalleryContainer: 'carousel__media-gallery__container--visible',
      },

      render: {
        carouselGallery: function renderCarouselGallery() {
          return Mustache.render(view.templates.mediaGalleryCarouselTemplate, {
            media: viewModel.carouselGalleryImages
          })
        },
        carouselGalleryButton: function renderCarouselGalleryButtons(position) {
          return Mustache.render(view.templates.mediaGalleryCarouselButton, {
            position: position
          })
        },
        thumbnails: function renderThumbnails() {
          return Mustache.render(view.templates.thumbnails, {
            thumbnails: viewModel.visibleThumbnails,
            additionalThumbnailsThumbnail: viewModel.summaryThumbnail,
            additionalImagesCount: viewModel.additionalThumbnailsCount,
            additionalThumbnails: viewModel.additionalThumbnails
          });
        }
      },

      initDomEventListeners: function viewInitDomEventListeners() {
        $(window).off('resize.breakpoints');
        $(window).on('resize.breakpoints', function resizeBreakPoints() {
          debounce(function() {
            view.updateDom.addCarousel();
            view.updateDom.toggleCarouselVisibility();
          }(), 250);
        });
        $(window.document).off('.openExpandedView').on('click.openExpandedView', view.selectors.openExpandedView, function expandMediaView() {
          viewModel.updateActiveMedia($(this).data('media_id'), $(this).data('media_type'));
          pipEvents.media.expandMediaView.trigger({
            analyticsMessage: pipAnalyticsMessaging.events.overlays.expandMediaView,
            target: event.target
          });
        });
      },

      initEventListeners: function viewInitEventListeners() {
        pipEvents.media.closeMediaView.off('.mediaPlayer');
        pipEvents.media.closeMediaView.on('.mediaPlayer', function () {
          pipMediaManager.updateActiveMedia();
        });
      },

      updateDom: {
        addThumbnails: function updateDomAddThumbnails() {
          $(view.selectors.thumbnails).html(view.render.thumbnails());
        },
        selectThumbnail: function updateDomSelectThumbnail(selector) {
          var target = selector || view.selectors.mediaThumbnail;
          $(target).removeClass(view.classes.selectedMediaThumbnail);
          $(target + '[data-media_id="' + viewModel.activeId + '"]').addClass(view.classes.selectedMediaThumbnail);
        },
        addCarousel: function updateDomAddCarousel() {
          if (breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small') && !viewModel.mediaGalleryCarouselInitialized) {
            $(view.selectors.carouselMediaGallery).html(view.render.carouselGallery);
            $(view.selectors.mainImageCarousel).owlCarousel(viewModel.getCarouselOptions());
            viewModel.mediaGalleryCarouselInitialized = true;
          }
        },
        toggleCarouselVisibility: function updateDomToggleCarouselVisibility() {
          var isSmallBreakPoint = breakpoints.isActiveBreakpointEqualToOrSmallerThan('Small');

          $(view.selectors.mainImage).toggleClass(view.classes.hiddenMainImage, isSmallBreakPoint);
          $(view.selectors.mediaGalleryContainer).toggleClass(view.classes.visibleMediaGalleryContainer, isSmallBreakPoint);
        }
      },

      init: function initView() {
        view.initEventListeners();
        view.initDomEventListeners();
        view.updateDom.addCarousel();
        view.updateDom.addThumbnails();
        view.updateDom.selectThumbnail();
      }
    };

    var viewModel = {
      visibleThumbnails: [],
      summaryThumbnail: '',
      additionalThumbnailsCount: 0,
      additionalThumbnails: [],
      carouselGalleryImages: [],
      activeId: '',
      mediaGalleryCarouselInitialized: false,

      updateActiveMedia: function updateActiveMedia(mediaId, mediaType) {
        pipMediaManager.updateActiveMedia(mediaId, mediaType);
        viewModel.activeId = pipMediaManager.active.id;
      },

      getCarouselOptions: function getCarouselOptions() {
        var carouselOptions = {
          itemClass: view.classes.carouselItemClass,
          items: 1,
          lazyLoad: true,
          lazyLoadEager: 1,
          loop: true,
          onInitialized: function carouselOnInitialized() {
            view.updateDom.toggleCarouselVisibility();
          },
          responsive: {
            0: {
              items: 1
            },
          },
          responsiveClass: true,
          responsiveRefreshRate: 0,
          slideBy: 1,
        };
        return carouselOptions;
      },

      initThumbnails: function initThumbnails() {
        var allThumbnails = model.data.thumbnails.slice(0);

        if (allThumbnails.length <= 1) {
          viewModel.visibleThumbnails = allThumbnails;
        } else if (allThumbnails.length - 1 <= NUMBER_OF_THUMBNAILS_TO_DISPLAY) {
          viewModel.visibleThumbnails = allThumbnails.slice(1, allThumbnails.length);
        } else {
          viewModel.visibleThumbnails = allThumbnails.slice(1, NUMBER_OF_THUMBNAILS_TO_DISPLAY);
          viewModel.summaryThumbnail = allThumbnails[NUMBER_OF_THUMBNAILS_TO_DISPLAY];
          viewModel.additionalThumbnailsCount = allThumbnails.length - NUMBER_OF_THUMBNAILS_TO_DISPLAY;
          viewModel.additionalThumbnails = allThumbnails.slice(NUMBER_OF_THUMBNAILS_TO_DISPLAY, allThumbnails.length);
        }
      },

      init: function initViewModel() {
        viewModel.updateActiveMedia();
        viewModel.initThumbnails();
        viewModel.carouselGalleryImages = model.data.carouselGalleryImages;
        viewModel.mediaGalleryCarouselInitialized = false;
      }
    };

    var model = {
      data: {},

      init: function initModel() {
        model.data.thumbnails = pipMediaManager.getThumbnails();
        model.data.carouselGalleryImages = pipMediaManager.get1000Images();
      },

    };

    return {
      init: function() {
        model.init();
        viewModel.init();
        view.init();
      },
      view: view,
      viewModel: viewModel,
      model: model
    }
  });

}.call(window));